<form
  id="mes-informations-signup"
  accept-charset="UTF-8"
  [formGroup]="form"
  class="px-5 mt-3"
>
  <fieldset
    class="w-100 border rounded-3 px-4 pb-4 d-flex flex-column align-items-center gap-3"
  >
    <legend class="float-none w-auto px-3 fw-semibold text-primary">
      {{ label }}
    </legend>
    <div class="align-self-end text-danger">
      <sup>*</sup><span class="mandatory-field">Champs obligatoires</span>
    </div>
    <div class="d-flex align-items-center gap-4 w-100">
      <p-input
        class="w-100"
        [formControl]="form.controls.firstname"
        id="firstname"
        name="firstname"
        label="Prénom"
        placeholder="Ex : Jean"
        [errorMessage]="getErrorMessage('firstname')"
      ></p-input>
      <p-input
        class="w-100"
        [formControl]="form.controls.lastname"
        id="lastname"
        name="lastname"
        label="Nom"
        placeholder="Ex : Dupont"
        [errorMessage]="getErrorMessage('lastname')"
      ></p-input>
    </div>
    <p-input
      class="w-100"
      [formControl]="form.controls.email"
      id="email"
      name="email"
      label="Adresse mail"
      type="email"
      placeholder="Ex : jean.dupont@gmail.com"
      [errorMessage]="getErrorMessage('email')"
    ></p-input
    ><div class="w-100 d-flex flex-column gap-1">
      <p-input
        class="w-100"
        [formControl]="form.controls.login"
        id="login"
        name="login"
        label="Identifiant Utilisateur"
        placeholder="Ex : jean.dupont"
        [errorMessage]="getErrorMessage('login')"
        [helpTextRight]="loginInfo"
        (inputBlur)="onVerifyLogin()"
        (inputChange)="onLoginInputChange()"
      ></p-input>
      <small
        class="text-danger align-self-start m-0 p-0"
        *ngIf="loginAlreadyExists"
      >
        Cet identifiant est déjà utilisé. Merci d'en choisir un autre.
      </small>
    </div>
  </fieldset>
</form>
